//------------------------------------------------------ funciones
import {
  subscribeTable,
  createRow,
  updateRow,
  deleteRow,
} from "../supabaseRealtime";
import { supabase } from "../../supabase/SupabaseClient";

const TABLA = "clientes";

// -------------------------------------------------- realtime

export const subscribeClientes = (callback) =>
  subscribeTable(TABLA, (rows) => {
    const activos = rows
      .filter((c) => String(c.estado) !== "0")
      .sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
    callback(activos);
  });

// -------------------------------------------------- metodos

const generarIdCliente = async () => {
  const { data: nuevo, error } = await supabase.rpc("incrementar_contador", {
    tabla: "contadores",
    fila_id: "clientes",
  });
  if (error) throw error;
  return `CL${String(nuevo).padStart(8, "0")}`;
};

export const createCliente = async ({ nombre, detalle = "" }) => {
  const id = await generarIdCliente();
  await createRow(TABLA, id, { nombre, detalle, estado: "1" });
  return id;
};

export const updateCliente = (id, data) => updateRow(TABLA, id, data);

export const deleteCliente = (id) => deleteRow(TABLA, id);
